import React  from "react";
import { useParams } from 'react-router-dom';
import RegisteredAnimalsForm from "../components/RegisteredAnimalsForm";
import { ANIMAL_TYPE_SWINE } from "variables/constants";

const EditSwine = () => {
	const { swineId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<RegisteredAnimalsForm recordId={swineId ?? 0} mode="edit" animalTypeId={ANIMAL_TYPE_SWINE}/>
	      </div>
	    </div>
    );
};

export default EditSwine;